






































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getRoutePath } from "@/router/routes";

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    ButtonComponent,
    FooterComponent
  }
})
export default class SensorDiagramsDefaultComponent extends Vue {
  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
